import { render, staticRenderFns } from "./DateFollowUp.vue?vue&type=template&id=5e7d5046&scoped=true"
import script from "./DateFollowUp.vue?vue&type=script&lang=js"
export * from "./DateFollowUp.vue?vue&type=script&lang=js"
import style0 from "./DateFollowUp.vue?vue&type=style&index=0&id=5e7d5046&prod&scoped=true&lang=css"
import style1 from "./DateFollowUp.vue?vue&type=style&index=1&id=5e7d5046&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7d5046",
  null
  
)

export default component.exports